
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!assignments.never_drop_collection";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'assignments/NeverDropCollection';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <button\n    class=\"btn btn-link add_never_drop";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.canChangeDropRules), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n    ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.canChangeDropRules), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    type=\"button\"\n  >"
    + escapeExpression((helper = helpers.addIcon || (depth0 && depth0.addIcon),options={hash:{},data:data},helper ? helper.call(depth0, "add", options) : helperMissing.call(depth0, "addIcon", "add", options)))
    + "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.hasNeverDrops), {hash:{},inverse:self.program(8, program8, data),fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </button>\n";
  return buffer;
  }
function program2(depth0,data) {
  
  
  return " disabled";
  }

function program4(depth0,data) {
  
  
  return "aria-disabled=true";
  }

function program6(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "add_another_assignment_fc5c908f", "Add another assignment", options) : helperMissing.call(depth0, "t", "add_another_assignment_fc5c908f", "Add another assignment", options)))
    + "\n    ";
  return buffer;
  }

function program8(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "add_an_assignment_fb73942e", "Add an assignment", options) : helperMissing.call(depth0, "t", "add_an_assignment_fb73942e", "Add an assignment", options)))
    + "\n    ";
  return buffer;
  }

  buffer += "<div class=\"never_drop collectionViewItems\"> </div>\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.hasAssignments), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  